import { relative } from 'path';
import { Subscription } from 'rxjs';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { GestorConviteCadastro } from 'src/app/models/gestor-convite-cadastro';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import {
    FormBuilder,
    FormGroup,
    FormControl,
    Validators
} from '@angular/forms';
import { GestorService } from 'src/app/services/gestor.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { PerfilService } from 'src/app/services/perfil.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { Perfil } from 'src/app/models/perfil';
import { PerfilNormalizado } from 'src/app/shared/enums/perfil-normalizado.enum';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CedenteGestor } from 'src/app/models/cedentegestor';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { Gestor } from 'src/app/models/gestor';
import { Cedente } from 'src/app/models/cedente';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-gestor-edit',
    templateUrl: './gestor-edit.component.html',
    styleUrls: ['./gestor-edit.component.css']
})
export class GestorEditComponent implements OnInit {
    constructor(
        private formBuilder: FormBuilder,
        private gestorService: GestorService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private perfilService: PerfilService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private parametrosDataService: ParametrosDataService
    ) { }

    public InNameHasNumber: boolean;
    public MASKS = MASKS;
    public gestorConviteFormGroup: FormGroup;
    public currentUser: Auth;
    gestorConviteCadastro: GestorConviteCadastro;
    private id: string;
    private routeSubscription: Subscription;
    public cedenteGestor: CedenteGestor = new CedenteGestor(null, null, null, null, null, null, new Gestor(null, null, null, null, null), new Cedente(null, null, null, null, null, null), []);

    public perfisList: Perfil[];
    perfilSelected: boolean;
    arraySelect: number[];

    public isResponsavel = false;

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.createForm(null);
        this.routeSubscription = this.route.paramMap.subscribe(params => {
            this.id = params.get('id');

            if (this.id) {
                this.loadGestor();
            }
        });
        this.InNameHasNumber = false;
    }

    public get form() {
        return this.gestorConviteFormGroup.controls;
    }

    private loadGestor() {
        this.gestorService
            .getGestor(this.id, this.currentUser.token.assignorGuid)
            .subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.cedenteGestor = response.result;
                        this.loadLists();

                        this.cedenteGestor.gestor.pessoa.documento = this.CompleteWithZero(
                            this.cedenteGestor.gestor.pessoa.documento
                        );

                        this.InNameOnBlur(
                            this.cedenteGestor.gestor.pessoa.pessoaFisica
                                .pessoaNome
                        );

                        this.isResponsavel = this.cedenteGestor.perfisGestor.find(x => x.perfilNomeNormalizado === PerfilNormalizado.Responsavel) != null;

                        this.createForm(this.cedenteGestor);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao buscar as informações!');
                }
            );
    }

    InNameOnFocus() {
        this.InNameHasNumber = false;
    }

    InNameOnBlur(value: string) {
        if (!value) {
            return;
        }

        if (value.replace(/\D+/g, '').replace(' ', '').length > 0) {
            this.InNameHasNumber = true;
        } else {
            this.InNameHasNumber = false;
        }
    }

    public CompleteWithZero(documento: string) {
        if (!documento) {
            return;
        }

        let zeros = '';

        for (let i = 0; i < 11 - documento.toString().length; i++) {
            zeros += '0';
        }

        documento = this.formataCPF(zeros + documento);
        return documento;
    }

    formataCPF(cpf) {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    private loadLists() {
        this.perfilService.getAllPerfil().subscribe(response => {
            if (response.status === ApiError.Sucesso) {
                this.perfisList = response.result.filter(
                    x => x.nomeNormalizado !== PerfilNormalizado.Responsavel
                );

                this.loadViewConfig();

                for (
                    let i = 0;
                    i < this.cedenteGestor.perfisGestor.length;
                    i++
                ) {
                    for (let j = 0; j < this.perfisList.length; j++) {
                        if (
                            this.perfisList[j].perfilId ==
                            this.cedenteGestor.perfisGestor[i].perfilId
                        ) {
                            this.perfisList[j].isChecked = true;
                            this.perfisList[j].selected = true;
                        }
                    }
                }
            } else {
                this.alertService.error(response.message);
            }
        });
    }

    loadViewConfig() {
        const parametros = this.parametrosDataService.currentParametrosValue;
        if (parametros) {
            if (parametros[ParametrosKey.perfisPermitidosConviteGestor]) {
                const perfisPermitidos = [];

                parametros[ParametrosKey.perfisPermitidosConviteGestor].forEach(
                    element => {
                        perfisPermitidos.push(
                            this.perfisList.find(x => x.perfilId === element)
                        );
                    }
                );

                if (
                    parametros[
                    ParametrosKey.labelPersonalizadaNomePerfilCadastro
                    ]
                ) {
                    const perfilCadastro = perfisPermitidos.find(
                        x => x.nome === 'Cadastro'
                    );
                    if (perfilCadastro) {
                        perfilCadastro.nome =
                            parametros[
                            ParametrosKey.labelPersonalizadaNomePerfilCadastro
                            ];
                    }
                }

                this.perfisList = perfisPermitidos;
            }
        }
    }

    private createForm(cedenteGestor: CedenteGestor) {
        if (cedenteGestor == null) {
            this.gestorConviteFormGroup = this.formBuilder.group({
                nome: new FormControl('', [
                    Validators.required,
                    Validators.minLength(3),
                    Validators.maxLength(100)
                ]),
                cpf: new FormControl('', [
                    Validators.required,
                    NgBrazilValidators.cpf
                ]),
                email: new FormControl('', [
                    Validators.required,
                    Validators.email
                ]),
                telefone: new FormControl('', [
                    Validators.required,
                    GenericValidator.isCellPhone,
                    NgBrazilValidators.telefone
                ]),
            });
        }

        if (cedenteGestor != null) {
            this.gestorConviteFormGroup = this.formBuilder.group({
                nome: new FormControl(
                    cedenteGestor.gestor.pessoa.pessoaFisica.pessoaNome,
                    [
                        Validators.required,
                        Validators.minLength(3),
                        Validators.maxLength(100)
                    ]
                ),
                cpf: new FormControl(
                    cedenteGestor.gestor.pessoa.documento,
                        
                    [Validators.required, NgBrazilValidators.cpf]
                ),
                email: new FormControl(cedenteGestor.gestor.email, [
                    Validators.required,
                    Validators.email
                ]),
                telefone: new FormControl((cedenteGestor?.telefone != null ? cedenteGestor.telefone.ddd+''+cedenteGestor.telefone.numero : ''), [
                ]),
            });
        }
    }

    isChecked() {
        this.perfilSelected = null;
        this.arraySelect = [];
        this.perfisList.forEach(obj => {
            if (obj.selected) {
                this.arraySelect.push(obj.perfilId);
                this.perfilSelected = true;
            }
        });
        if (this.perfilSelected !== true) {
            this.perfilSelected = false;
        }
    }

    goToBack() {
        this.router.navigate(['../../list'], { relativeTo: this.route });
    }

    onSubmit(gestorConviteCadastro: GestorConviteCadastro) {
        gestorConviteCadastro.perfisId = [];

        if (
            this.gestorConviteFormGroup.valid &&
            (this.perfilSelected || this.isResponsavel) &&
            !this.InNameHasNumber
        ) {
            if (!this.isResponsavel) {
                gestorConviteCadastro.perfisId = this.arraySelect.slice(0);
            } else {
                gestorConviteCadastro.perfisId.push(1); // responsável
            }

            gestorConviteCadastro.telefone = gestorConviteCadastro.telefone.replace(/\D+/g, '').replace(' ', '');

            this.gestorService
                .edit(
                    gestorConviteCadastro,
                    this.cedenteGestor.gestor.gestorGuid,
                    this.currentUser.token.assignorGuid
                )
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.alertService.success(response.message);
                        } else {
                            this.alertService.error(response.message);
                        }
                    },
                    error => {
                        this.alertService.error('Ocorreu um erro ao buscar as informações!');
                    }
                );
        } else {
            this.isChecked();
            GenericValidator.verifierValidatorsForm(
                this.gestorConviteFormGroup
            );
        }
    }

    public telefoneCelularMask = (telefone: any) => {
        telefone = telefone.replace(/\D+/g, '').replace(' ', '');
        if (telefone.length <= 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        } else if (telefone.length > 10) {
            return ['(',/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/];
        }
    }
}
